import { gql } from '@apollo/client';

const schema = {
  create: {
    name: "createProductCategory",
    serviceName: "admin",
    query: gql`
      mutation createProductCategory(
        $title: String!
        $parent_id: String
      ) {
        createProductCategory(
          title: $title
          parent_id: $parent_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
